<script setup lang="ts">
import type { ShipexkursIconName } from '~/utils/shipexkurs-icons';

defineProps<{
  /** Eigenes SC-Symbol aus `shipexkurs-icons.ts`. */
  icon?: ShipexkursIconName;
  /** Alternativ ein Lucide-Icon (z.B. "i-lucide-zap"), wenn kein eigenes Symbol passt. */
  uiIcon?: string;
  value: string | number;
  unit?: string;
  /** Gedimmte Darstellung für nicht zutreffende/leere Werte (z.B. 0 Turret-DPS auf einem reinen Fixed-Weapons-Schiff). */
  muted?: boolean;
  /** Überschreibt die Standardfarbe (`text-aris-400`) des Icons, z.B. `"text-error-400"`. */
  iconClass?: string;
}>();
</script>

<template>
  <div class="flex items-center gap-2" :class="muted ? 'opacity-35' : ''">
    <ShipexkursSystemIcon v-if="icon" :name="icon" class="size-5 shrink-0" :class="iconClass ?? 'text-aris-400'" />
    <UIcon v-else-if="uiIcon" :name="uiIcon" class="size-5 shrink-0" :class="iconClass ?? 'text-aris-400'" />
    <span class="text-xl font-bold text-white">{{ value }}</span>
    <span v-if="unit" class="text-xs text-neutral-500">{{ unit }}</span>
  </div>
</template>
